"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamGameAggregateParamsSchema = exports.TeamGameAggregateCountParamsSchema = exports.TeamGameAggregateFieldSchema = exports.TeamGameAggregateRequestFieldSchema = exports.MultiTeamAggregateCountParamsSchema = exports.MultiTeamAggregateParamsSchema = exports.MultiTeamAggregateFieldSchema = exports.MultiTeamAggregateRequestFieldSchema = exports.TeamAggregatesParamsSchema = void 0;
const zod_1 = require("zod");
const util_1 = require("../util");
const query_1 = require("./query");
const teamAggregate_1 = require("./teamAggregate");
const util_2 = require("./util");
const translationQuery_1 = require("./translationQuery");
const TeamSequenceAggregateFieldSchema = zod_1.z.union((0, util_2.schemaKeys)(teamAggregate_1.TeamSequenceAggregateSchema));
exports.TeamAggregatesParamsSchema = (0, query_1.filterParamsSchema)(TeamSequenceAggregateFieldSchema).strict();
const MultiTeamAggregateRequestSchema = zod_1.z.object({
    input: teamAggregate_1.TeamSequenceAggregateSchema,
    output: teamAggregate_1.MultiTeamAggregateSchema,
});
exports.MultiTeamAggregateRequestFieldSchema = (0, util_1.aggregateKeysSchema)(MultiTeamAggregateRequestSchema, 'output.aggregates');
exports.MultiTeamAggregateFieldSchema = (0, util_1.aggregateKeysSchema)(teamAggregate_1.MultiTeamAggregateSchema, 'aggregates');
exports.MultiTeamAggregateParamsSchema = (0, query_1.filterParamsSchema)(exports.MultiTeamAggregateRequestFieldSchema)
    .extend({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    // Order by only allows keys that are in the response.
    order_by: zod_1.z.record(exports.MultiTeamAggregateFieldSchema, query_1.SortOrderSchema).optional(),
})
    .extend(translationQuery_1.LanguageParamsSchema.shape)
    .extend(query_1.ColumnsParamSchema.shape)
    .strict();
exports.MultiTeamAggregateCountParamsSchema = (0, query_1.filterParamsSchema)(exports.MultiTeamAggregateRequestFieldSchema).strict();
/** Single Team across multiple games schemas */
const TeamGameAggregateRequestSchema = zod_1.z.object({
    input: teamAggregate_1.TeamSequenceAggregateSchema,
    output: teamAggregate_1.TeamGameAggregateSchema,
});
exports.TeamGameAggregateRequestFieldSchema = (0, util_1.aggregateKeysSchema)(TeamGameAggregateRequestSchema, 'output.aggregates');
exports.TeamGameAggregateFieldSchema = (0, util_1.aggregateKeysSchema)(teamAggregate_1.TeamGameAggregateSchema, 'aggregates');
exports.TeamGameAggregateCountParamsSchema = (0, query_1.filterParamsSchema)(exports.TeamGameAggregateRequestFieldSchema).strict();
exports.TeamGameAggregateParamsSchema = exports.TeamGameAggregateCountParamsSchema.extend({
    offset: query_1.OffsetSchema,
    limit: query_1.LimitSchema,
    // Order by only allows keys that are in the response.
    order_by: zod_1.z.record(exports.TeamGameAggregateFieldSchema, query_1.SortOrderSchema).optional(),
})
    .extend(translationQuery_1.LanguageParamsSchema.shape)
    .extend(query_1.ColumnsParamSchema.shape)
    .strict();
//# sourceMappingURL=teamAggregateQuery.js.map